var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9917 56.8577L30.6242 60.5502C29.5278 60.9063 28.3575 60.2592 28.0627 59.1447C24.6731 46.3302 21.943 39.1002 16.9776 28.6085C16.4627 27.5204 17.0091 26.2223 18.1507 25.8404L27.9401 22.5651C28.8749 22.2524 29.9004 22.6701 30.3494 23.5477C36.1131 34.8137 39.1053 42.1358 43.2641 54.3125C43.6241 55.3664 43.0509 56.5137 41.9917 56.8577Z",
    fill: "#FFA502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3581 50.836L60.9907 54.5285C59.8943 54.8846 58.724 54.2375 58.4292 53.123C55.0396 40.3085 52.3095 33.0785 47.3441 22.5868C46.8291 21.4987 47.3755 20.2006 48.5171 19.8186L58.3066 16.5434C59.2414 16.2306 60.2669 16.6484 60.7158 17.526C66.4796 28.792 69.4718 36.1141 73.6306 48.2908C73.9905 49.3447 73.4173 50.492 72.3581 50.836Z",
    fill: "#1E90FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3296 110.705L38.5717 100.654C37.8036 99.6586 38.1501 98.2019 39.2683 97.6274C77.5009 77.9837 89.5645 60.3734 95.2372 21.4297C95.4076 20.2599 96.5447 19.4669 97.6945 19.7414L110.075 22.6968C111.142 22.9513 111.8 24.0373 111.552 25.105C100.297 73.4479 86.0731 92.601 48.8079 111.265C47.957 111.692 46.9111 111.458 46.3296 110.705Z",
    fill: "#FF6348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9d1decf00afdfcd6b87832014aeaf18e.svg";
export { ForwardRef as ReactComponent };